// extracted by mini-css-extract-plugin
export default {"subMenu":"TemplatesMenuItem-module__subMenu--ajzfX","header":"TemplatesMenuItem-module__header--L4lOl","animatedBackground":"TemplatesMenuItem-module__animatedBackground--X6Q1e"};